import { ApplicantProfileTab } from "../store/workspace/types";

interface ApplicantProfileTabItem {
    id: ApplicantProfileTab;
    title: string;
};

export const applicantProfileTabs: ApplicantProfileTabItem[] = [
    {
        id: 'Personal',
        title: 'Personal information',
    },
    {
        id: 'WorkExperience',
        title: 'Work experience',
    },
    {
        id: 'Education',
        title: 'Education',
    },
    {
        id: 'Expertise',
        title: 'Expertise',
    },
    {
        id: 'Files',
        title: 'Uploaded files',
    },
    {
        id: 'Identify',
        title: 'Identifying',
    },
];
